import React from 'react'
import { Flex } from '@chakra-ui/core'
import { StatusTag } from './StatusTag'
import { RatingStars } from './RatingStars'

interface StatusTagWithRatingProps {
  status: number // Supports: INPROGRESS (1), DONE (2), SKIPPED (-3), DISAPPROVED (3), APPROVED (4)
  rating: number
  size?: 'small' | 'medium'
  isShowRating?: boolean
}

export const StatusTagWithRating: React.FC<StatusTagWithRatingProps> = ({
  status,
  rating,
  size = 'medium',
  isShowRating = true,
}) => {
  const shouldShowRating = isShowRating && rating > 0

  return (
    <Flex alignItems="center" style={{ gap: '8px' }}>
      <StatusTag status={status} size={size} />
      {shouldShowRating && <RatingStars rating={rating} size={size} />}
    </Flex>
  )
}
